var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCitySidebarActiveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.5V10.6579L7.875 6.18421L14.75 10.6579V20.5H10.1667V14.2368H5.58333V20.5H1ZM23 3.5V20.5H16.5833V9.70053L15.6667 9.11V7.07895H13.8333V7.91105L10.1667 5.53105V3.5H23ZM20.25 14.2368H18.4167V16.0263H20.25V14.2368ZM20.25 10.6579H18.4167V12.4474H20.25V10.6579ZM20.25 7.07895H18.4167V8.86842H20.25V7.07895Z",
    fill: "#3DC2EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitySidebarActiveIcon);
export default __webpack_public_path__ + "static/media/citySidebarActiveIcon.0b8ae64597f0812c94c62c819f1783a0.svg";
export { ForwardRef as ReactComponent };